import { useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useAssetDetailWithFallback } from '../api/hooks';

export function AssetResolver() {
    const { ticker } = useParams<{ ticker: string }>();
    const location = useLocation();
    const navigate = useNavigate();

    const navState = location.state as { assetTypeHint?: string } | null;
    const typeHint = navState?.assetTypeHint || null;

    const { loading, error, resolvedType } = useAssetDetailWithFallback(
        ticker || null,
        typeHint
    );

    useEffect(() => {
        if (resolvedType && ticker) {
            navigate(`/markets/asset/${resolvedType}/${ticker}`, {
                replace: true,
            });
        }
    }, [resolvedType, ticker, navigate]);

    if (!ticker) return null;

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 8,
                }}
            >
                <CircularProgress size={24} />
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ textAlign: 'center', py: 8 }}>
                <Typography sx={{ color: 'error.main', fontSize: '14px' }}>
                    Asset "{ticker}" not found
                </Typography>
            </Box>
        );
    }

    return null;
}
